import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import Header from "../components/header"
import Footer from "../components/footer"

import GatsbyConfig from '../../gatsby-config'

import './index.styl'

const TemplateWrapper = ({children, data}) =>
  <div>
    <Helmet
      title="Accelerated Books from James Porter"
      meta={[
        { name: 'description', content: 'Learn modern software development techniques faster and better' },
      ]}
    />
    <Header />
    
    <div className="content">

    <div className="main-content">
      {children()}
      </div>
    </div>

    <Footer />
  </div>

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js